import { Observable } from 'rxjs';
import { EndpointsName, get } from "../../Auth";
import { Area, GroupedParsedChartData, OptionalChartInitialData, ProcessLine } from "../../types";
import { map } from 'rxjs/operators';
import { parseToChartData } from './chartConfig';

const buildChartParamEndpoint = (area: Area, param: string, line?: ProcessLine) => line ? `/mlc/${area}/${line}/trends/${param}` : `/mlc/${area}/trends/${param}`;

export const getMLCINTBLast30MinutesChartsData = (param: string, line: ProcessLine): Observable<Partial<GroupedParsedChartData>> =>
    get<OptionalChartInitialData>(EndpointsName.BBF, buildChartParamEndpoint(Area.INTB, param, line)).pipe(
        map(parseToChartData)
    );

export const getMLCTBCFLast30MinutesChartsData = (param: string): Observable<Partial<GroupedParsedChartData>> =>
    get<OptionalChartInitialData>(EndpointsName.BBF, buildChartParamEndpoint(Area.TBCF, param)).pipe(
        map(parseToChartData)
    );